import { Box, Stack, Typography } from '@mui/material';
import { translates } from '@/utils';
import Logo from '@/commons/logo';
import AuthLoginForm from '../../forms/login-form';

export const ContentLogin = () => (
  <Box sx={{ background: 'white' }} p={3} borderRadius="1rem" className="md:w-2/3">
    <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
      <Typography variant="h4" textAlign="center" className="md:text-5xl text-2xl">
        {translates['auth.login.title']}
      </Typography>
    </Stack>

    <AuthLoginForm />
  </Box>
);
